import { useHistory } from "react-router-dom";
import { withProcedureWraper } from "../..";
import { Routes } from "../../../../AppRoutes";
import { Box, Table, UserManual } from "../../../../components";
import { Icon } from "../../../../components";
import CreateRequestButton from "../../components/CreateRequestButton";
import { useBCColumns, useBCRequests } from "./hooks";
import { IBusinessCardResponse } from "./models/IBusinessCard";

const requestsFallback = [] as IBusinessCardResponse[];

const BusinessCard = withProcedureWraper(() => {
  const history = useHistory();
  const {
    requests = requestsFallback,
    myRequests = requestsFallback,
    isLoading,
  } = useBCRequests();
  const { columns } = useBCColumns();
  return (
    <div className="pd15">
      <UserManual title="Đề nghị in danh thiếp" icon={<Icon.IdCard />} />
      <Box
        title="Yêu cầu của tôi"
        titleRight={
          <CreateRequestButton
            onClick={() => history.push(Routes.createBusinessCard.path)}
          />
        }
      >
        <Table
          rowKey="id"
          loading={isLoading}
          columns={columns}
          dataSource={myRequests}
          onRow={(record) => ({
            onClick: () =>
              history.push(`${Routes.businessCard.path}/${record.id}`),
            style: { cursor: "pointer" },
          })}
        />
      </Box>
      <Box title="Yêu cầu cần duyệt">
        <Table
          rowKey="id"
          loading={isLoading}
          columns={columns}
          dataSource={requests}
          onRow={(record) => ({
            onClick: () =>
              history.push(`${Routes.businessCard.path}/${record.id}`),
            style: { cursor: "pointer" },
          })}
        />
      </Box>
    </div>
  );
});

export default BusinessCard;
